import { Type } from 'class-transformer';
import { SecondParty } from '@core/model/second-party.model';
import { Brand } from '@app/features/scope-overview/model/brand.model';

export class FolderIdentity {
  id!: number
  localId!: number
  archived!: boolean
  isTemplate!: boolean
  @Type(() => SecondParty) secondParty!: SecondParty;
  @Type(() => Brand) brand!: Brand;
  xlsxTemplate?: any
}
